import { createI18n } from "vue-i18n";
import cart from "./lang/cart";
import product from "./lang/product";
import flashMessage from "./lang/flash-message";
import modal from "./lang/modal";
import home from "./lang/home";
import faq from "./lang/faq";
import contactForm from "./lang/contact-form";

// translations
const i18n = createI18n({
  locale: document.documentElement.lang, // set locale
  fallbackLocale: "hu", // set fallback locale
  messages: {
    sk: {
      ...faq.sk,
      ...home.sk,
      ...modal.sk,
      ...flashMessage.sk,
      ...cart.sk,
      ...product.sk,
      ...contactForm.sk,
    },
    cs: {
      ...faq.cs,
      ...home.cs,
      ...modal.cs,
      ...flashMessage.cs,
      ...cart.cs,
      ...product.cs,
      ...contactForm.cs,
    },
    hu: {
      ...faq.hu,
      ...home.hu,
      ...modal.hu,
      ...flashMessage.hu,
      ...cart.hu,
      ...product.hu,
      ...contactForm.hu,
    },
  },
});

export { i18n };
